export default __webpack_public_path__ + "static/media/sm.83fe677c.svg";